import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaCheck, FaLightbulb, FaComments, FaChartLine, FaUserTie,
  FaBusinessTime, FaExchangeAlt, FaUserFriends, FaFileAlt,
  FaArrowRight, FaStar
} from 'react-icons/fa';
import { GiBrain } from 'react-icons/gi';

import WhatsAppButton from '../components/Whatsapp';

import imgRelatorio from '../assets/cursos/quatro-perfis-comportamentais_solides.webp';
import imgPessoas from '../assets/cursos/images.jpg';
import fundoDesktop from '../assets/cursos/FundoDesktop.png';

const LandingPage = () => {
  const navigate = useNavigate();

  const handleCheckout = (plan) => {
    navigate('/checkout', { state: { selectedPlan: plan } });
  };

  return (
    <div className="font-sans text-gray-900 antialiased">
      <WhatsAppButton />

      <section
        className="relative pt-24 md:pt-32 pb-16 md:pb-24 px-4 min-h-screen flex items-center text-white"
        style={{
          backgroundImage: `url(${fundoDesktop})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="relative max-w-6xl mx-auto w-full grid lg:grid-cols-2 gap-8 md:gap-16 items-center">
          <div className="p-6 md:p-8">
            <div className="flex items-center mb-4">
              <GiBrain className="text-green-400 text-3xl mr-2" />
              <span className="text-green-400 font-semibold">TESTE COMPORTAMENTAL</span>
            </div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 leading-tight">
              Descubra Seu Potencial em Apenas 15 Minutos
            </h1>
            <p className="text-lg md:text-xl mb-6">
              Identifique suas habilidades naturais e aprenda a usá-las para alcançar seus objetivos profissionais.
            </p>

            <ul className="space-y-3 mb-8">
              <li className="flex items-start">
                <FaCheck className="text-green-400 mt-1 mr-2 flex-shrink-0" />
                <span>Relatório completo do seu perfil</span>
              </li>
              <li className="flex items-start">
                <FaCheck className="text-green-400 mt-1 mr-2 flex-shrink-0" />
                <span>Análise de pontos fortes e fracos</span>
              </li>
              <li className="flex items-start">
                <FaCheck className="text-green-400 mt-1 mr-2 flex-shrink-0" />
                <span>Dicas personalizadas para desenvolvimento</span>
              </li>
            </ul>

            <button
              onClick={() => window.scrollTo({
                top: document.getElementById('planos').offsetTop - 100,
                behavior: 'smooth'
              })}
              className="bg-green-500 hover:bg-green-600 text-white px-8 py-3 rounded-lg font-bold text-lg transition transform hover:scale-105"
            >
              Ver Planos Disponíveis
            </button>
          </div>
        </div>
      </section>

      <section className="bg-white py-16 md:py-24 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center bg-green-50 px-6 py-2 rounded-full mb-4">
              <FaCheck className="text-green-500 text-xl mr-2" />
              <h2 className="text-xl font-semibold text-green-700">O QUE VOCÊ RECEBE</h2>
            </div>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900">Entenda seu perfil comportamental</h3>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <ul className="space-y-6">
                <li className="flex items-start p-4 rounded-lg hover:bg-gray-50 transition">
                  <div className="bg-green-100 p-3 rounded-full mr-4">
                    <FaFileAlt className="text-green-600 text-xl" />
                  </div>
                  <div>
                    <h4 className="text-xl font-semibold mb-2">Relatório completo</h4>
                    <p className="text-gray-600">
                      Seu perfil comportamental detalhado com gráficos e explicações claras sobre suas características.
                    </p>
                  </div>
                </li>
                <li className="flex items-start p-4 rounded-lg hover:bg-gray-50 transition">
                  <div className="bg-green-100 p-3 rounded-full mr-4">
                    <FaChartLine className="text-green-600 text-xl" />
                  </div>
                  <div>
                    <h4 className="text-xl font-semibold mb-2">Forças e oportunidades</h4>
                    <p className="text-gray-600">
                      Entenda claramente suas principais habilidades e áreas para desenvolvimento.
                    </p>
                  </div>
                </li>
                <li className="flex items-start p-4 rounded-lg hover:bg-gray-50 transition">
                  <div className="bg-green-100 p-3 rounded-full mr-4">
                    <FaComments className="text-green-600 text-xl" />
                  </div>
                  <div>
                    <h4 className="text-xl font-semibold mb-2">Devolutiva opcional</h4>
                    <p className="text-gray-600">
                      Na versão premium, agende uma sessão de 1h com nossa especialista para análise personalizada.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="order-1 lg:order-2">
              <div className="relative rounded-xl overflow-hidden shadow-xl">
                <img
                  src={imgRelatorio}
                  alt="Exemplo de relatório"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-50"></div>
                <div className="absolute bottom-0 left-0 p-6 text-white">
                  <p className="text-sm font-medium">Exemplo de relatório</p>
                  <h4 className="text-xl font-bold mt-1">Visualização do seu perfil</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-gray-50 py-16 md:py-24 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center bg-yellow-50 px-6 py-2 rounded-full mb-4">
              <FaLightbulb className="text-yellow-500 text-xl mr-2" />
              <h2 className="text-xl font-semibold text-yellow-700">IDEAL PARA</h2>
            </div>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900">Quem pode se beneficiar</h3>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="relative rounded-xl overflow-hidden shadow-xl">
                <img
                  src={imgPessoas}
                  alt="Pessoas trabalhando"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-50"></div>
                <div className="absolute bottom-0 left-0 p-6 text-white">
                  <p className="text-sm font-medium">Desenvolvimento profissional</p>
                  <h4 className="text-xl font-bold mt-1">Melhore suas relações</h4>
                </div>
              </div>
            </div>
            <div>
              <ul className="space-y-6">
                <li className="flex items-start p-4 rounded-lg hover:bg-white transition">
                  <div className="bg-yellow-100 p-3 rounded-full mr-4">
                    <FaUserTie className="text-yellow-600 text-xl" />
                  </div>
                  <div>
                    <h4 className="text-xl font-semibold mb-2">Profissionais</h4>
                    <p className="text-gray-600">
                      Que desejam se destacar no trabalho e entender suas melhores funções.
                    </p>
                  </div>
                </li>
                <li className="flex items-start p-4 rounded-lg hover:bg-white transition">
                  <div className="bg-yellow-100 p-3 rounded-full mr-4">
                    <FaBusinessTime className="text-yellow-600 text-xl" />
                  </div>
                  <div>
                    <h4 className="text-xl font-semibold mb-2">Empreendedores</h4>
                    <p className="text-gray-600">
                      Em busca de autoconhecimento para liderar com mais eficiência.
                    </p>
                  </div>
                </li>
                <li className="flex items-start p-4 rounded-lg hover:bg-white transition">
                  <div className="bg-yellow-100 p-3 rounded-full mr-4">
                    <FaExchangeAlt className="text-yellow-600 text-xl" />
                  </div>
                  <div>
                    <h4 className="text-xl font-semibold mb-2">Transição de carreira</h4>
                    <p className="text-gray-600">
                      Entenda suas habilidades naturais para escolher o próximo passo.
                    </p>
                  </div>
                </li>
                <li className="flex items-start p-4 rounded-lg hover:bg-white transition">
                  <div className="bg-yellow-100 p-3 rounded-full mr-4">
                    <FaUserFriends className="text-yellow-600 text-xl" />
                  </div>
                  <div>
                    <h4 className="text-xl font-semibold mb-2">Comunicação</h4>
                    <p className="text-gray-600">
                      Melhore suas relações entendendo seu estilo comunicativo.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section id="planos" className="bg-white py-16 md:py-24 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center bg-blue-50 px-6 py-2 rounded-full mb-4">
              <FaFileAlt className="text-blue-500 text-xl mr-2" />
              <h2 className="text-xl font-semibold text-blue-700">ESCOLHA SUA VERSÃO</h2>
            </div>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900">Opções disponíveis</h3>
          </div>

          <div className="grid lg:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div className="bg-white border-2 border-gray-200 rounded-xl p-8 shadow-sm hover:shadow-md transition hover:border-green-500">
              <div className="flex items-center mb-6">
                <div className="bg-green-100 p-3 rounded-full mr-4">
                  <FaFileAlt className="text-green-600 text-xl" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900">Versão Básica</h3>
              </div>
              <div className="mb-6">
                <span className="text-4xl font-bold">R$ 175,00</span>
                <span className="text-gray-500">/ teste</span>
              </div>
              <ul className="space-y-4 mb-8">
                <li className="flex items-center">
                  <FaCheck className="text-green-500 mr-3" />
                  <span>Relatório completo do seu perfil</span>
                </li>
                <li className="flex items-center">
                  <FaCheck className="text-green-500 mr-3" />
                  <span>Análise de pontos fortes</span>
                </li>
                <li className="flex items-center">
                  <FaCheck className="text-green-500 mr-3" />
                  <span>Áreas de desenvolvimento</span>
                </li>
                <li className="flex items-center">
                  <FaCheck className="text-green-500 mr-3" />
                  <span>Resultado imediato</span>
                </li>
              </ul>
              <button
                onClick={() => handleCheckout('basic')}
                className="w-full bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-lg transition"
              >
                Escolher esta opção
              </button>
            </div>

            <div className="bg-white border-2 border-gray-200 rounded-xl p-8 shadow-sm hover:shadow-md transition hover:border-blue-500">
              <div className="flex items-center mb-6">
                <div className="bg-blue-100 p-3 rounded-full mr-4">
                  <FaComments className="text-blue-600 text-xl" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900">Versão Premium</h3>
              </div>
              <div className="mb-6">
                <span className="text-4xl font-bold">R$ 350,00</span>
                <span className="text-gray-500">/ teste + sessão</span>
              </div>
              <ul className="space-y-4 mb-8">
                <li className="flex items-center">
                  <FaCheck className="text-blue-500 mr-3" />
                  <span>Todos os itens da versão básica</span>
                </li>
                <li className="flex items-center">
                  <FaCheck className="text-blue-500 mr-3" />
                  <span>Sessão de 1h com especialista</span>
                </li>
                <li className="flex items-center">
                  <FaCheck className="text-blue-500 mr-3" />
                  <span>Análise personalizada</span>
                </li>
                <li className="flex items-center">
                  <FaCheck className="text-blue-500 mr-3" />
                  <span>Plano de ação individual</span>
                </li>
              </ul>
              <button
                onClick={() => handleCheckout('premium')}
                className="w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-6 rounded-lg transition"
              >
                Escolher esta opção
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-gray-50 py-16 md:py-24 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center bg-purple-50 px-6 py-2 rounded-full mb-4">
              <FaStar className="text-purple-500 text-xl mr-2" />
              <h2 className="text-xl font-semibold text-purple-700">DEPOIMENTOS</h2>
            </div>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900">O que dizem nossos clientes</h3>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              {
                quote: "Foi muito além do que eu esperava. O relatório me deu insights valiosos sobre como me comunicar melhor com minha equipe.",
                author: "Carlos M., Gerente",
                rating: 5
              },
              {
                quote: "A devolutiva com a especialista foi o ponto alto. Ela me ajudou a entender como aplicar meu perfil no dia a dia.",
                author: "Ana P., Empreendedora",
                rating: 5
              },
              {
                quote: "Incrível para tomar decisões com mais segurança. Agora entendo porque certas atividades me cansam mais que outras.",
                author: "Roberto S., Designer",
                rating: 5
              }
            ].map((testimonial, index) => (
              <div key={index} className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition">
                <div className="flex mb-3">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <FaStar key={i} className="text-yellow-400" />
                  ))}
                </div>
                <p className="text-gray-800 italic mb-4">"{testimonial.quote}"</p>
                <p className="text-gray-600 font-semibold">- {testimonial.author}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-gradient-to-r from-green-600 to-green-700 py-20 px-4 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <GiBrain className="text-5xl mx-auto mb-6 text-green-300" />
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Pronto para descobrir seu potencial?</h2>
          <p className="text-xl md:text-2xl mb-8 max-w-2xl mx-auto">
            Comece agora e receba seu relatório completo em minutos.
          </p>

          <div className="max-w-md mx-auto">
            <button
              onClick={() => window.scrollTo({
                top: document.getElementById('planos').offsetTop - 100,
                behavior: 'smooth'
              })}
              className="w-full bg-white text-green-700 px-8 py-4 rounded-full text-lg font-bold hover:bg-gray-100 transition transform hover:scale-105 shadow-lg hover:shadow-xl"
            >
              Fazer meu teste agora <FaArrowRight className="inline ml-2" />
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LandingPage;